var React = require('react');

function Radio (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"3.5","cy":"11.5","r":"2","stroke":"currentColor","key":0}),React.createElement("circle",{"cx":"11.5","cy":"11.5","r":"2","stroke":"currentColor","key":1}),React.createElement("path",{"d":"M13.5 12V3.5C13.5 2.94772 13.0523 2.5 12.5 2.5H6.5C5.94772 2.5 5.5 2.94772 5.5 3.5V12","stroke":"currentColor","strokeLinecap":"round","key":2}),React.createElement("path",{"d":"M5 6H13","stroke":"currentColor","key":3})]);
}

Radio.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Radio;

Radio.default = Radio;
